/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Money} from "./money.zod";
import {OfferCurrencyConversion} from "./offerCurrencyConversion.zod";

export const SelectedSupplierFacts = zod
  .unknown()
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(
    zod.object({
      supplierId: zod.uuid(),
      catalogItemId: zod.uuid(),
      supplierName: zod.string(),
      priceProtected: zod.boolean(),
      priceAvailability: zod.enum(["AVAILABLE", "RESTRICTED", "UNAVAILABLE"]),
      unitPrice: Money.optional(),
      minimumOrderQuantity: zod.number(),
      orderQuantityMultiple: zod.number(),
      quantityPerSoldUnit: zod.number(),
      effectiveQuantity: zod.number(),
      conversionAvailability: zod.enum(["NOT_REQUIRED", "AVAILABLE", "RESTRICTED", "UNAVAILABLE"]),
      conversion: OfferCurrencyConversion.optional(),
    }),
  )
  .describe(
    "Native Money retains its original Currency. Known original price with unavailable converted cost is lawful. Private price and conversion associations remain omitted together. Same-Currency inputs need no publication. Technical failure is not unavailable price.",
  );

export type SelectedSupplierFacts = zod.input<typeof SelectedSupplierFacts>;
export type SelectedSupplierFactsOutput = zod.output<typeof SelectedSupplierFacts>;
